import { useState } from 'react';
import { STUDIO_GENDER_ASSETS } from '../constants/studioGenderAssets';
import { useStudioMobileViewport } from '../hooks/useStudioMobileViewport';
import StudioCardHoverMedia from './StudioCardHoverMedia';
import {
	GenderCardImage,
	GenderCardMain,
	GenderCardMen,
	GenderCardTrans,
	GenderStageSection,
} from '../studio.styles';

const GENDER_CARD_COMPONENTS = {
	trans: GenderCardTrans,
	woman: GenderCardMain,
	men: GenderCardMen,
};

const GenderStage = ({ labels, selectedGender, onSelect }) => {
	const isMobile = useStudioMobileViewport();
	const [hoveredValue, setHoveredValue] = useState(null);

	return (
		<GenderStageSection data-studio-panel="gender" aria-label={labels.chooseGender}>
			{STUDIO_GENDER_ASSETS.map((card) => {
				const Component = GENDER_CARD_COMPONENTS[card.value];
				const isVideoActive = isMobile || hoveredValue === card.value;

				return (
					<Component
						key={card.value}
						type="button"
						aria-label={labels[card.labelKey]}
						aria-pressed={selectedGender === card.value}
						data-selected={selectedGender === card.value ? 'true' : undefined}
						$selected={selectedGender === card.value}
						$dimmed={Boolean(selectedGender) && selectedGender !== card.value}
						onClick={() => onSelect(card.value)}
						{...(isMobile
							? {}
							: {
									onMouseEnter: () => setHoveredValue(card.value),
									onMouseLeave: () => setHoveredValue(null),
								})}
					>
						<GenderCardImage>
							<StudioCardHoverMedia
								imageSrc={card.image}
								videoSrc={card.video}
								videoFallback={card.videoFallback}
								alt={labels[card.labelKey]}
								priority={Boolean(card.priority)}
								isActive={isVideoActive}
							/>
						</GenderCardImage>
						<span>{labels[card.labelKey]}</span>
					</Component>
				);
			})}
		</GenderStageSection>
	);
};

export default GenderStage;
